import { Component } from '@angular/core';

@Component({
    moduleId: module.id,
    selector: 'footer-cmp',
    templateUrl: 'footer.component.html'
})

export class FooterComponent{
    test : Date = new Date();
}



// WEBPACK FOOTER //
// ./src/app/shared/footer/footer.component.ts